import { IRoutePermissions } from '../../types/common';
import { UserCapabilityName } from '../../types/userCapabilityName';

export const policyManagerRoutePerm: IRoutePermissions = {
  userCapabilities: [
    UserCapabilityName.SuperAdmin,
    UserCapabilityName.ViewInternalAccessPolicies,
  ],
};
